import { useState, useMemo } from 'react';

import { SortableProp } from 'types';

const useSortableData = <T>(items: T[], defaultSort: SortableProp | null) => {
  const [sortConfig, setSortConfig] = useState<SortableProp | null>(defaultSort);

  const sortedItems = useMemo(() => {
    const sortableItems = [...items];

    sortableItems.sort((a: T, b: T) => {
      if (sortConfig !== null && sortConfig?.key !== undefined) {
        const key = sortConfig.key;
        if (a[key as keyof T] < b[key as keyof T]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[key as keyof T] > b[key as keyof T]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
      }
      return 0;
    });
    return sortableItems;
  }, [items, sortConfig]);

  const requestSort = (key: string) => {
    let direction = 'ascending';
    if (
      sortConfig !== null &&
      sortConfig.key === key &&
      sortConfig.direction === 'ascending'
    ) {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  return { items: sortedItems, requestSort, sortConfig };
};

export default useSortableData;
